/* @flow */
export const DeliveryStatus = {
  SENT: 'sent',
  READ: 'read',
  DELIVERED: 'delivered',
  DELIVERY_ERROR: 'delivery_error',
  PENDING_INITIAL_ACK: 'pending_initial_ack',
};

export type DeliveryStatusType = (
  'sent' |
  'read' |
  'delivered' |
  'delivery_error' |
  'pending_initial_ack'
);



// WEBPACK FOOTER //
// ./src/chat/constants/DeliveryConstants.js